import React, { useState } from "react";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import Step from "@mui/material/Step";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

import { styled } from "@mui/material/styles";
import { useTheme } from "@emotion/react";

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 30,
  alignItems: "center",
  ...(ownerState.active && {}),
  "& .QontoStepIcon-completedIcon": {
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  "& .QontoStepIcon-circle-completed": {
    width: 30,
    height: 30,
    borderRadius: "50%",
  },
}));

function QontoStepIcon(props) {
  const theme = useTheme();
  const { active, completed, className, icon } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed || active ? (
        <div className="QontoStepIcon-circle-completed">
          <div
            style={{
              background: theme.palette.stepper.activeBubbleOuterColor,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: theme.size[30],
              width: theme.size[30],
              borderRadius: "50%",
            }}
          >
            <div
              style={{
                background: theme.palette.stepper.activeBubbleInnerColor,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: theme.size[12],
                height: theme.size[23],
                width: theme.size[23],
                borderRadius: "50%",
                color: theme.palette.stepper.activeBubbleTextColor,
              }}
            >
              {icon}
            </div>
          </div>
        </div>
      ) : (
        <div className="QontoStepIcon-circle">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: 12,
              height: 30,
              width: 30,
              borderRadius: "50%",
              color: theme.palette.stepper.pendingBubbleTextColor,
            }}
          >
            {icon}
          </div>
        </div>
      )}
    </QontoStepIconRoot>
  );
}

const CustomisedConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      height: 2,
      backgroundColor: theme.palette.stepper.activeConnectorColor,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      height: 2,
      backgroundColor: theme.palette.stepper.activeConnectorColor,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1,
    border: theme.size[10],
    backgroundColor: theme.palette.stepper.pendingConnectorColor,
    borderRadius: 1,
  },
}));

function CustomStepper({ steps, activeStep }) {
  return (
    <div>
      <Stepper
        activeStep={activeStep}
        orientation="horizontal"
        connector={<CustomisedConnector />}
        sx={{
          flexWrap: "nowrap", // keep steps on one line
          overflowX: "auto", // allow scroll if too many steps
        }}
      >
        {steps.map((stepValue) => (
          <Step
            key={stepValue.id}
            sx={(theme) => ({
              "& .MuiStepLabel-label": {
                whiteSpace: "nowrap", // prevent wrapping
                overflow: "hidden", // hide overflow text
                textOverflow: "ellipsis", // show "..."
                maxWidth: "220px", // set max width (adjust as needed)
                display: "block",
                fontFamily: theme.typography.fontFamily,
              },
              "& .MuiStepLabel-root .Mui-completed": {
                color: theme.palette.stepper.activeBubbleInnerColor,
                fontFamily: theme.typography["fontFamily"],
              },
              "& .MuiStepLabel-root .Mui-active": {
                color: theme.palette.stepper.activeBubbleInnerColor,
                fontFamily: theme.typography["fontFamily"],
              },
              "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                {
                  color: theme.palette.stepper.activeTextColor,
                  fontFamily: theme.typography["fontFamily"],
                },
              "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                fill: theme.palette.stepper.activeBubbleTextColor,
                fontFamily: theme.typography["fontFamily"],
              },
              "& .MuiStepLabel-horizontal .Mui-disabled": {
                color: theme.palette.stepper.pendingTextColor,
                opacity: 0.5,
                fontFamily: theme.typography["fontFamily"],
              },
              "& .MuiStepLabel-iconContaine .Mui-disabled": {
                color: theme.palette.stepper.pendingBubbleTextColor,
                fill: theme.palette.stepper.pendingBubbleTextColor,
                fontFamily: theme.typography["fontFamily"],
              },
            })}
          >
            <StepLabel StepIconComponent={QontoStepIcon}>
              {stepValue.name}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

export default CustomStepper;
